export enum EventTypes {
  DELETE_ITEM = 'deleteItem',
}

export interface ListItem {
  label: string;
  value: number | string;
}
